import React, { useCallback, useEffect } from 'react';
// import { feedsListAllColumnsView } from './FeedsListTableSpec';
import { useFeedsListTableInit } from './useFeedsListTableInit';
import { useFeedsListTableState } from './useFeedsListTableState';
import TableTop from '../../../../core/table/TableTop';
import TableBody from '../../../../core/table/TableBody';
import { useFeedsData } from './useFeedsData';
import TableHead from '../../../../core/table/TableHead';
// import { getFeedsListTableSchema } from './feedsListTableSchema';
import { FeedsDataItem } from '../feeds_list_types';
// import TableViewEditForm from '../../../../core/table/TableViewEditForm';
// import FlyOutMenu from '../../../../core/components/FlyOutMenu';
// import { LegacyTableView } from '../../../../core/table/table-view.types';
// import { tableStateAtom } from '../feeds_list_atoms';
// import { useTableViewSelection } from '../../../../core/table/hooks/useTableViewSelection';
// import { convertToLegacyTableViews } from '../../../../core/table/utils/tableViewHelpers';
// import { useSetImmerAtom } from 'jotai-immer';
// import TableViewEditControls from '../../../../core/table/TableViewEditControls';
// import { FEEDS_LIST_VIEW_KEY } from '../../feeds_const';
// import { useTableViewPersistence } from '../../../../core/table/hooks/useTableViewPersistence';
import { useFeedsStore } from '../pagehooks/useFeedsStore';
import TablePaging from '../../../../core/table/TablePaging';
import TableExceedsDataSizeMessage from '../../../../core/table/TableExceedsDataSizeMessage';
import TableList from '../../../../core/table/TableList';
// import { getFeedsInitialView } from './getFeedsInitialView';

export const feedsListTableId = 'opsFeedsList';

// const feedsTableSpec = feedsListAllColumnsView();

type FeedsListTableProps = {
    onClick?: (row: FeedsDataItem) => void;
    showTableViewEditor?: boolean;
    onRefetchReady?: (refetch: () => Promise<void>) => void;
    isExternalFlyOutOpen?: boolean; // When row click FlyOut is open
    showTableFlyOut?: boolean;
    setShowTableFlyOut: (open: boolean) => void;
    // ref for the click-outside "ignore" region: only the grid, not the top stats/messages
    gridRef?: React.RefObject<HTMLTableElement>;
};

const FeedsListTable = ({
    onClick,
    showTableViewEditor = false,
    isExternalFlyOutOpen = false,
    showTableFlyOut = false,
    setShowTableFlyOut,
    gridRef,
}: FeedsListTableProps): JSX.Element => {
    const { init } = useFeedsListTableInit();

    if (init) {
        return <></>;
    }

    // Simplified: Always render the table instead of blocking on init
    return (
        <TableWrapper
            onClick={onClick}
            showTableViewEditor={showTableViewEditor}
            isExternalFlyOutOpen={isExternalFlyOutOpen}
            showTableFlyOut={showTableFlyOut}
            setShowTableFlyOut={setShowTableFlyOut}
            gridRef={gridRef}
        />
    );
};

type TableWrapperProps = FeedsListTableProps & {
    showTableViewEditor?: boolean;
    isExternalFlyOutOpen?: boolean;
};

const TableWrapper = ({
    onClick,
    // showTableViewEditor,
    isExternalFlyOutOpen = false,
    // showTableFlyOut = false,
    setShowTableFlyOut,
    gridRef,
}: TableWrapperProps & { showTableFlyOut?: boolean; setShowTableFlyOut?: (open: boolean) => void }): JSX.Element => {
    // const [flyOutMode, setFlyOutMode] = useState<SavedViewsFlyOutMode>('CREATE');
    // const setTableState = useSetImmerAtom(tableStateAtom);

    // Remove local state, use parent state
    // const showFlyOut = showTableFlyOut;
    // Wrap setShowTableFlyOut in useCallback for stable reference
    const setShowFlyOut = useCallback(
        (open: boolean) => {
            if (setShowTableFlyOut) setShowTableFlyOut(open);
        },
        [setShowTableFlyOut],
    );

    const {
        fltStats,
        paging,
        sort,
        filters,
        // currentViewId,
        setPaging,
        setFilter,
        setSort,
        // setCurrentViewId,
        // views: rawTableViews,
        cols,
        sections,
    } = useFeedsListTableState();
    const { items, rawDataSize } = useFeedsData();
    const { action, loading } = useFeedsStore();

    // Convert all views to legacy format using helper
    // const legacyViews: LegacyTableView[] = convertToLegacyTableViews(rawTableViews);
    // SINGLE SOURCE OF TRUTH FOR PERSISTENCE LOGIC
    // **This needs to be called at this parent level, otherwise
    // we risk breakage**
    // const {
    //     editingView,
    //     handleEditView,
    //     handleViewDelete,
    //     handleCreateView,
    //     handleCloseFlyOut,
    //     handleFlyOutSave,
    //     tableViews,
    // } = useTableViewPersistence({
    //     tableViews: legacyViews,
    //     tableId: FEEDS_LIST_VIEW_KEY,
    //     setCurrentViewId,
    //     setTableState,
    //     flyOutMode,
    //     setFlyOutMode,
    //     setShowFlyOut,
    //     colMap: feedsListColumnSpec(),
    //     // Use getFeedsInitialView for Default view spec and section mapping
    //     defaultView: getFeedsInitialView(),
    // });

    // const { viewFilteredColumns, viewFilteredSections } = useTableViewSelection({
    //     tableId: FEEDS_LIST_VIEW_KEY,
    //     tableViews,
    //     currentViewId,
    //     setCurrentViewId,
    //     columnSpec: feedsListColumnSpec,
    //     defaultView: getFeedsInitialView,
    //     allColumnsView: feedsListAllColumnsView,
    //     setTableState,
    // });

    // const schema = useMemo(() => getFeedsListTableSchema(), []);
    const isTableDisabled = isExternalFlyOutOpen;

    /* Only used for features that have Saved Views. Not the most elegant, but works for now. */
    useEffect(() => {
        if (action === 'QUERY') {
            setShowFlyOut(false);
        }
    }, [action, setShowFlyOut]);

    // don't show table
    if (action !== 'LIST' || loading) {
        return <></>;
    }

    // const initialSort = tableViewFormGetInitialSort(flyOutMode, editingView, feedsTableSpec.sortby);

    return (
        <TableList>
            <TableExceedsDataSizeMessage dataSize={rawDataSize} />
            <TableTop
                id={feedsListTableId}
                fltStats={fltStats}
                // topRight={
                //     showTableViewEditor ? (
                //         <TableViewEditControls
                //             views={tableViews}
                //             currentViewId={currentViewId}
                //             setCurrentViewId={setCurrentViewId}
                //             handleEditView={handleEditView}
                //             handleCreateView={handleCreateView}
                //         />
                //     ) : undefined
                // }
            />
            <table
                ref={gridRef}
                className={isTableDisabled ? 'disabled-interaction' : ''}
            >
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={onClick}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
            {/* <FlyOutMenu
                title={flyOutMode === 'CREATE' ? 'Create Table View' : 'Edit Table View'}
                isOpen={showFlyOut}
                onClose={(): void => setShowFlyOut(false)}
                width={500}
                overflowY="scroll"
            >
                {showFlyOut && (
                    <TableViewEditForm
                        schema={schema}
                        mode={flyOutMode}
                        views={tableViews}
                        editingView={editingView}
                        onSave={handleFlyOutSave}
                        onCancel={handleCloseFlyOut}
                        onRemove={handleViewDelete}
                        initialSort={initialSort}
                    />
                )}
            </FlyOutMenu> */}
        </TableList>
    );
};

export default FeedsListTable;
